import { Badge } from '@/components/ui/badge'
import type { JobStatus } from '@/types'

const VARIANT: Record<JobStatus, 'default' | 'secondary' | 'destructive' | 'success' | 'outline'> = {
  queued: 'secondary',
  processing: 'outline',
  completed: 'success',
  failed: 'destructive',
  cancelled: 'outline',
}

export function StatusBadge({ status }: { status: JobStatus }) {
  return (
    <Badge variant={VARIANT[status]} className="capitalize">
      {status}
    </Badge>
  )
}
